import _taggedTemplateLiteral from 'babel-runtime/helpers/taggedTemplateLiteral';

var _templateObject = _taggedTemplateLiteral(['\n  flex-grow: 1;\n  flex-shrink: 0;\n  flex-basis: ', ';\n  margin: 0 ', 'px;\n  max-width: calc(', ' - ', 'px);\n  min-width: calc(99.9999% / ', ' - ', 'px);\n  word-wrap: break-word;\n'], ['\n  flex-grow: 1;\n  flex-shrink: 0;\n  flex-basis: ', ';\n  margin: 0 ', 'px;\n  max-width: calc(', ' - ', 'px);\n  min-width: calc(99.9999% / ', ' - ', 'px);\n  word-wrap: break-word;\n']);

import styled from 'styled-components';

import { spacing } from './vars';

var getColumnRatio = function getColumnRatio(props) {
  if (props.medium === props.theme.columns) {
    return '100%';
  }
  return '99.9999% / ' + props.theme.columns + ' * ' + props.medium;
};
var getColumnWidth = function getColumnWidth(props) {
  return props.medium > 0 ? 'calc(' + getColumnRatio(props) + ' - ' + spacing[props.theme.spacing] + 'px)' : 'auto';
};
var availableColumns = function availableColumns(props) {
  return props.theme.columns;
};
var specifiedColumns = function specifiedColumns(props) {
  return props.medium ? props.medium : availableColumns(props);
};
var columns = function columns(props) {
  return Math.min(availableColumns(props), specifiedColumns(props));
};
var gridSpacing = function gridSpacing(props) {
  return spacing[props.theme.spacing];
};
var getMaxWidthColumnRatio = function getMaxWidthColumnRatio(props) {
  if (columns(props) >= availableColumns(props)) {
    return '100%';
  }
  return '99.9999% / ' + availableColumns(props) + ' * ' + columns(props);
};

// Unable to use the flexbox shorthand rules because Styled Components doesn't
// handle them correctly for IE11.
// Also IE11 and Edge both have rounding issues for flexbox which is why a width of
// 99.9999% is used. Using 100% here causes columns to wrap prematurely.
var GridColumn = styled.div(_templateObject, getColumnWidth, function (props) {
  return spacing[props.theme.spacing] / 2;
}, getMaxWidthColumnRatio, gridSpacing, availableColumns, gridSpacing);

export default GridColumn;
export { getColumnWidth };


//////////////////
// WEBPACK FOOTER
// ./node_modules/@atlaskit/page/dist/esm/internal/GridColumnElement.js
// module id = 669
// module chunks = 0